import ProspectiveBuyer from './ProspectiveBuyer.component';

export default ProspectiveBuyer;